export default __webpack_public_path__ + "static/media/avatar.6573cbba.png";